<template>
  <div class="text-base/5 text-neutral-500 font-bold md:mr-3 2xl:mr-8">
    <slot />
  </div>
</template>
